import React, { useState } from 'react';
import {
    useStylesUp,  useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl

} from '../../../../St/Reports/UseStyle';
import { AppBar, Button, ButtonGroup,CssBaseline, Fab, Hidden, Paper, Toolbar } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ReplyIcon from "@material-ui/icons/Reply";
import CircularProgress from "@material-ui/core/CircularProgress";
import { insh } from "../../../../Context/InshSt";
import { stElemnt } from "../../../../St/comps/cStyle";
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage, Print, Reply, Update } from '@material-ui/icons';

export default function RestrictionAppBar(props) {
    const { t } = useTranslation(["forms", "translation"]);

    const {
        params,
        buttonClassnameNew,
        buttonClassnameSave,
        buttonClassnameDelete,
        clasCAB,
        newToI,
        setting,
        deleteToI,
        addToBS,
        loading,
        clasBA,
        backHome,
        back,
        uiElement,
        prevent,
        paramsList,
        isLoading,
        setConfirmDialog,
        openButtonsSearch,
        setOpenButtonsSearch,
        procIdSearch,
        onClickButton,
        setOpenSearchMdl,
        openUpdate,
        setOpenUpdate,
        print
    } = props;
    const clasup = useStylesUp();
    const [styles, setStyles] = useState(insh.bascData);

    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const [mouseInterA, setMouseInterA] = useState(false);
    const [mouseInterB, setMouseInterB] = useState(false);
    const [mouseInterC, setMouseInterC] = useState(false);
    const [mouseInterD, setMouseInterD] = useState(false);
    const [style, setStyle] = useState(insh.account);
    const clickPrint = () => {
        if (prevent) {
            addToBS("print");
        } else {
            if (openUpdate) {
                addToBS("print");
            } else {
                print();
            }
        }
    };
    const clickUpdate = () => {
        setOpenUpdate(true);
    };
    const buttons = [
        <Button key="last"
            style={{ color: openButtonsSearch ? "#fff" : "#d3d3d3", borderRadius: 0, borderBottom: 'solid 1px white' }}
            onClick={(event) => onClickButton(procIdSearch, "last")}
            name={"last"}
            onMouseEnter={() => setMouseInterA(true)}
            onMouseLeave={() => setMouseInterA(false)}
            disabled={!openButtonsSearch}
        >
            <FirstPage />
            {mouseInterA && openButtonsSearch && (
                <div className='tooltip'>
                    {"الاخير"}
                </div>
            )}
        </Button>,

        <Button key="previous"
            style={{ color: openButtonsSearch ? "#fff" : "#d3d3d3", borderRadius: 0, borderBottom: 'solid 1px white' }}
            disabled={openButtonsSearch == true ? procIdSearch === 0 ? true : false : false}
            onClick={(event) => onClickButton(procIdSearch, "before")}
            onMouseEnter={() => setMouseInterB(true)}
            onMouseLeave={() => setMouseInterB(false)}
        >
            <ArrowBackIos />
            {mouseInterB && openButtonsSearch && (
                <div className='tooltip'>
                    {"السابق"}
                </div>
            )}
        </Button>,
        <Button key="next"
            style={{ color: openButtonsSearch ? "#fff" : "#d3d3d3", borderRadius: 0, borderBottom: 'solid 1px white' }}
            disabled={openButtonsSearch == true ? procIdSearch === 0 ? true : false : false}
            onClick={(event) => onClickButton(procIdSearch, "next")}
            name={"next"}
            onMouseEnter={() => setMouseInterC(true)}
            onMouseLeave={() => setMouseInterC(false)}

        >
            <ArrowForwardIos />
            {mouseInterC && openButtonsSearch && (
                <div className='tooltip'>
                    {"التالي"}
                </div>
            )}
        </Button>,

        <Button key="first"
            hidden={true}
            style={{ color: openButtonsSearch ? "#fff" : "#d3d3d3", borderRadius: 0, borderBottom: 'solid 1px white' }}
            disabled={!openButtonsSearch}
            onClick={(event) => onClickButton(procIdSearch, "first")}
            onMouseEnter={() => setMouseInterD(true)}
            onMouseLeave={() => setMouseInterD(false)}
        >
            <LastPage />
            {mouseInterD && openButtonsSearch && (
                <div className='tooltip'>
                    {"الاول"}
                </div>
            )}
        </Button>,

    ];
    return (
        <React.Fragment>
            <CssBaseline />

            <AppBar
                position="fixed"
                color="primary"
                style={{
                    backgroundImage: "linear-gradient(160deg, #808080 , #808080)", ...stElemnt.all.appBarBA,
                    direction: "ltr"
                }}
            >

                <Toolbar className={clasBA.ToolbarBA} variant="dense" >
                    <Hidden only={["xs"]}>
                        {props.isDialogData ?
                            (
                                <>
                                    <Button
                                        style={{ color: "#fff" }}
                                        onClick={props.onClose}
                                        startIcon={<CloseIcon />}
                                    >
                                        {"Esc "}   {t("forms:exit")}
                                    </Button>
                                    { }
                                    <Button
                                        style={{ color: "#fff" }}
                                        onClick={() => props.onClose()}
                                        startIcon={<ReplyIcon />}
                                    >
                                        {t("forms:back")}
                                    </Button>
                                </>
                            ) :
                            (
                                <>
                                    <Button
                                        style={{ color: "#fff" }}
                                        onClick={backHome}
                                        startIcon={<CloseIcon />}
                                    >
                                        {"Esc "}   {t("forms:exit")}
                                    </Button>
                                    <Button
                                        style={{ color: "#fff" }}
                                        onClick={() => back()}
                                        startIcon={<ReplyIcon />}
                                    >
                                        {t("forms:back")}
                                    </Button>
                                    <Button
                                        style={{ color: "#fff" }}
                                        // disabled={prmis?.Se}
                                        onClick={() => setOpenSearchMdl(true)}
                                        startIcon={<SearchIcon />}
                                    >
                                        {"F9 "}   {t("search")}
                                    </Button>
                                </>
                            )
                        }
                    </Hidden>
                    <Hidden smUp={["sm"]}>
                        {props.isDialogData ?
                            (
                                <>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="open drawer"
                                        onClick={props.onClose}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="open drawer"
                                        onClick={() => props.onClose()}
                                    >
                                        <ReplyIcon />

                                    </IconButton>

                                </>
                            ) :
                            (
                                <>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="open drawer"
                                        onClick={backHome}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="open drawer"
                                        onClick={() => back()}
                                    >
                                        <ReplyIcon />

                                    </IconButton>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="searsh"
                                        onClick={() => setOpenSearchMdl(true)}
                                    // disabled={prmis?.Se}
                                    >
                                        <SearchIcon />
                                    </IconButton>
                                    <div style={{ alignContent: "right", edge: "end", marginRight: "0.5rem" }}>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            aria-label="new"

                                            disabled={loading.new}
                                            onClick={(e) => newToI(1000)}
                                        >
                                            <AddIcon />
                                        </IconButton>
                                        {loading.new && (
                                            <CircularProgress size={24} className={clasCAB.buttonProgressCAB} />
                                        )}
                                    </div>
                                </>
                            )}


                        {!prevent === true ? (
                            <div style={{ alignContent: "right" }}>
                                <IconButton
                                    edge="end"
                                    color="inherit"
                                    aria-label="delete"
                                    onClick={(e) =>
                                        setConfirmDialog({
                                            isOpen: true,
                                            onConfirm: () => {
                                                deleteToI(e, params.id, setting.screen)
                                            },
                                        })
                                    }
                                >
                                    <DeleteIcon />
                                </IconButton>
                                {loading.delete && (
                                    <CircularProgress
                                        size={24}
                                        className={clasCAB.buttonProgressCAB}
                                    />
                                )}
                            </div>
                        ) : null}
                    </Hidden>

                    {!props.isDialogData && (
                        <Hidden only={["xs"]}>
                            <div className={clasCAB.wrapperCAB}>
                                <ButtonGroup
                                    orientation="horizontal"
                                    aria-label="horizontal primary button group"
                                    other
                                    style={{ marginLeft: "1rem" }}
                                >
                                    {buttons}

                                </ButtonGroup>
                                {loading.print || loading.save && (
                                    <CircularProgress
                                        size={24}
                                        className={clasCAB.buttonProgressCAB}
                                    />
                                )}
                                <Button style={{ color: '#fff' }}
                                    onClick={() => setOpenButtonsSearch(true)}
                                    startIcon={<Reply />} >
                                    {"F8 "}  {"تراجع"}
                                </Button>

                            </div>
                        </Hidden>
                    )}

                    <div className={clasBA.growBA} />




                    <Hidden smUp={["sm"]}>


                        {!prevent &&
                            (
                                <>
                                    <div className={clasCAB.wrapperCAB}>
                                        <Fab
                                            size="medium"
                                            color="primary"
                                            // disabled
                                            style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                            className={buttonClassnameDelete}
                                            onClick={(e) => {
                                                setConfirmDialog({
                                                    isOpen: true,
                                                    onConfirm: () => {
                                                        deleteToI(e, params.id, setting.screen)
                                                    },
                                                })
                                            }}
                                        >
                                            {<DeleteIcon />}
                                        </Fab>
                                    </div>
                                    <div className={clasCAB.wrapperCAB}>
                                        <Fab
                                            size="medium"
                                            color="primary"
                                            style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                            onClick={(event) => clickUpdate()}

                                            disabled={openUpdate}
                                        >
                                            <Update />
                                        </Fab>
                                    </div>
                                </>
                            )}


                        <div className={clasCAB.wrapperCAB}>
                            <Fab
                                size="medium"
                                color="primary"
                                disabled={isLoading}
                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                className={buttonClassnameSave}
                                // onClick={() => addToBS("print")}
                                onClick={() => clickPrint()}
                            >
                                {<Print />}
                            </Fab>

                            {(loading.print || loading.save) && (
                                <CircularProgress
                                    size={56}
                                    className={clasCAB.fabProgressCAB}
                                />
                            )}
                        </div>
                        <div className={clasCAB.wrapperCAB}>
                            <Fab
                                size="medium"
                                color="primary"
                                disabled={!prevent && !openUpdate ? true : isLoading}
                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                className={buttonClassnameSave}
                                onClick={() => addToBS("save")}
                            >
                                {" "}
                                {<SaveIcon />}
                            </Fab>

                            {(loading.print || loading.save) && (
                                <CircularProgress
                                    size={56}
                                    className={clasCAB.fabProgressCAB}
                                />
                            )}
                        </div>


                    </Hidden>
                    <Hidden only={["xs"]}>

                        {prevent === false ? (

                            <div className={clasCAB.wrapperCAB}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    className={buttonClassnameDelete}
                                    startIcon={<DeleteIcon />}
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    // disabled={loading.delete}
                                    disabled={isLoading}
                                    onClick={(e) => {
                                        setConfirmDialog({
                                            isOpen: true,
                                            onConfirm: () => {
                                                deleteToI(e, params.id, setting.screen)
                                            },
                                        })
                                    }}
                                >
                                    {"F6 "}   {t("forms:delete")}
                                </Button>
                                {loading.delete && (
                                    <CircularProgress
                                        size={24}
                                        className={clasCAB.buttonProgressCAB}
                                    />
                                )}
                            </div>
                        ) : null}
                        {!prevent &&
                            (
                                <div className={clasCAB.wrapperCAB}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                        className={buttonClassnameSave}
                                        // disabled={loading.save}
                                        disabled={openUpdate}
                                        onClick={() => clickUpdate()}
                                        startIcon={<Update />}
                                    >
                                        {" "} :
                                        {"F4 "}   {t("update")}
                                    </Button>
                                    {loading.save && (
                                        <CircularProgress size={24} className={clasCAB.buttonProgressCAB} />
                                    )}
                                </div>
                            )}
                        <div className={clasCAB.wrapperCAB}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                className={buttonClassnameSave}
                                disabled={isLoading}
                                onClick={() => clickPrint()}
                                // onClick={(e) => addToBS("print")}
                                startIcon={<Print />}
                            >
                                {" "} :
                                {"F7 "}  {prevent ? t("save-print") : t("print")}{" "}
                            </Button>
                            {loading.save && (
                                <CircularProgress size={24} className={clasCAB.buttonProgressCAB} />
                            )}
                        </div>


                        <div className={clasCAB.wrapperCAB}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                className={buttonClassnameSave}
                                // disabled={loading.save}
                                disabled={!prevent && !openUpdate ? true : isLoading}
                                onClick={(e) => addToBS("save")}
                                startIcon={<SaveIcon />}
                            >
                                {"F3 "} {prevent ? t("forms:save") : t("forms:save-update")}{" "}
                            </Button>
                            {loading.save && (
                                <CircularProgress size={24} className={clasCAB.buttonProgressCAB} />
                            )}
                        </div>
                        {!props.isDialogData &&
                            (
                                <div className={clasCAB.wrapperCAB}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                        className={buttonClassnameNew}
                                        // disabled={loading.new}
                                        disabled={isLoading}

                                        onClick={() => newToI(1000)}

                                        startIcon={<AddIcon />}
                                    >
                                        {" "}
                                        {"F2 "}{t("forms:new")}{" "}
                                    </Button>
                                    {loading.new && (
                                        <CircularProgress size={24} className={clasCAB.buttonProgressCAB} />
                                    )}
                                </div>
                            )}

                    </Hidden>
                </Toolbar>
            </AppBar>
        </React.Fragment >
    );

}